import { useAppSelector } from "../../hooks/StoreHooks";

export const useAppDesignCompanyLogo = () =>
    useAppSelector((state) => state.configuration.appDesign.companyLogo);

export const useLogoUploadNeeded = () =>
    useAppSelector((state) => {
        const { companyLogo, companyLogoBase64 } = state.configuration.appDesign;
        return !!companyLogo || !!companyLogoBase64;
    });

export const useAppDesignAccentColor = () =>
    useAppSelector((state) => state.configuration.appDesign.accentColor);

export const useConfigEditMode = () =>
    useAppSelector((state) => state.configuration.configEditMode);